__turbopack_context__.v({
  "card": "_8NbvW_card",
  "checkboxWrapper": "_8NbvW_checkboxWrapper",
  "control": "_8NbvW_control",
  "error": "_8NbvW_error",
  "formInput": "_8NbvW_formInput",
  "help": "_8NbvW_help",
  "icon": "_8NbvW_icon",
  "imageWrapper": "_8NbvW_imageWrapper",
  "label": "_8NbvW_label",
  "link": "_8NbvW_link",
  "loginWrapper": "_8NbvW_loginWrapper",
  "passwordVisible": "_8NbvW_passwordVisible",
  "privacyInfo": "_8NbvW_privacyInfo",
});
